<template>
    <div class="overview-topbar white-bkg by-1 p-5 mt--5 ml--5">
            <div class="overview-topbar-wrapper container-big m-auto">
                <div v-for="(topbar, indexTopbar) in dataTopBar" :key="indexTopbar">

                    <div v-if="indexTopbar == 'main'" class="overview-topbar-main-content clearfix">
                        <div class="info-wrapper dinlineb pt-2">

                            <!-- AVATAR -->
                            <staff-picker :currentStaffId="topbar.id"/>

                            <!-- CONTACT INFOS -->
                            <div class="dinlineb valign-middle ml-5" v-for="(data, indexData) in topbar.datas" :key="indexData" v-if="data.value != ''">
                                <p class="info-label m-0 pt-2">{{ data.label }}</p>
                                <p class="info-value">{{ data.value }}</p>
                            </div>
                        </div>

                        <!-- CTA -->
                        <div class="actions-wrapper fright pl-4 bl-1 fs-3 semibold ">
                            <div v-if="dataTopBar.actions">
                                <el-dropdown trigger="click">
                                    <a href="javascript:;" class="el-dropdown-link block px-2 py-1">
                                        {{ dataTopBar.actions.options.links.title }}
                                    </a>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(link,keylink) in dataTopBar.actions.options.links.datas" :key="keylink">
                                            <a :href="link.value">{{ link.label }}</a>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>

                            <a class="block px-2 py-1" href="javascript:;" @click="showDetails = !showDetails;">
                                {{ $l10n.__('Voir plus') }}
                                <i v-if="!showDetails" class="fa icon-caret-down-fillout ml-2"></i>
                                <i v-else class="fa icon-caret-top-fillout ml-2"></i>
                            </a>
                        </div>
                    </div>

                    <!-- SUBMENU -->
                    <div class="submenu-wrapper mt-4 pt-5 bt-1" v-if="indexTopbar == 'sub'" v-show="showDetails" >
                        <div v-for="(block, indexBlock) in topbar.subData" :key="indexBlock" class="submenu dinlineb prelative valign-top span_6">
                            <h3 class="info-category m-0">{{ block.title }}</h3>
                            <div v-for="(subBlock, indexSubBlock) in block.datas" :key="indexSubBlock">
                                <div v-if="subBlock.value != ''">
                                    <p class="info-label m-0 pt-2">{{ subBlock.label }}</p>
                                    <p class="info-value">{{ subBlock.value }}</p>
                                </div>
                            </div>

                            <div v-if="block.staffs">
                                <p class="info-label m-0 pt-2">{{ $l10n.__("Membres du groupe") }}</p>
                                <ul class="staff-container m-0">
                                    <li class="dinlineb mt-2 ml-2" v-for="(staff, indexStaff) in block.staffs" :key="indexStaff">
                                        <a :href="urlStaff(staff)">
                                            <div class="avatar" :class="{'avatar-picture' : staff.avatar.type == 'picture'}">
                                                <img v-if="staff.avatar.type == 'picture'" :src="staff.avatar.value" />
                                                <span v-else>
                                                    {{ staff.avatar.value }}
                                                </span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    import StaffPicker from './../StaffPicker.vue';

    export default{
        props: {
            dataTopBar: {
                type: Object,
                require: true
            }
        },
        data(){
            return {
                showDetails : false
            }
        },
        methods: {
            urlStaff(staff){
                if(staff.url){
                    return staff.url;
                } else{
                    return '/staff/'+staff.id;
                }
            }
        },
        components: {
            'staff-picker' : StaffPicker
        }
    }
</script>

<style lang='scss' scoped>
    @import '~@sellsy/styleguide/src/_variables';
    
    .overview-topbar{
        width : calc(100% + 56px);
        
        .overview-topbar-wrapper {

            .avatar-wrapper {
                .staff-detail {
                    .staff-name {
                        font-size : 20px;
                    }
                }
            }

            .submenu-wrapper {
                .submenu {

                    &:first-of-type {
                        &::after {
                            content             : " ";
                            position            : absolute;
                            top                 : 0;
                            bottom              : 0;
                            right               : 0px;
                            width               : 1px;
                            height              : calc(100% - 32px);
                            margin              : auto;
                            background-color    : lightgrey;
                        }
                    }

                    &:last-of-type {
                        padding-left : 32px;
                    }

                    .staff-container {
                        width : 232px;

                        li {
                            &:nth-of-type(6n + 1){
                                margin-left : 0 !important;
                            }
                        }
                    }
                }
            }
        }
    }
</style>